import React, { useState, useEffect, useRef, memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";

import { FiDownload, FiEye, FiEdit } from "react-icons/fi";
import moment from "moment";
import PatientForm from "../Forms/PatientForm";
import axiosInst from "../../../Config";
import { Decrypt_Value } from "../../../MiddleWare/EncryptDecrypt";

import {
  getUpdateDocumentslist,
  getDeleteDocumentslist,
  getPreviewDocument,
  getViewEditDocument,
  getDeleteTempDoc,
  getPreviewDownload,
  getDownloadCredentials,
  getDownloadLabCredentials,
  getDeleteLabCredentials,
  setDeleteLabCredentials,
  getDocumentslist,
  getEditDataEmpty,
  setPreviewDocument,
} from "../../../StateManagement/Reducers/DocumentsState";

import CreateSignature from "../CreateSignature";
import ViewEdit from "../ViewEdit";
import EmptyData from "../../StyledComponents/EmptyData";
import Error from "../../../Modules/StyledComponents/Toastify/Error";

import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableHeadCell,
  TableBodyCell,
  Image,
  FlexJustCenter,
} from "../../StyledComponents";
import {
  TableDiv,
  ProfileNameText,
  StatusDiv,
  StatusText,
  DropdownList,
  DropdownContent,
  Iframe,
  LinkA,
} from "./styles";

import { BsThreeDots } from "react-icons/bs";
import Download from "../../../Assets/images/Download.png";
import Delete from "../../../Assets/images/Delete.png";
import forward from "../../../Assets/images/forward.png";
import printer from "../../../Assets/images/printer.png";
import { TitleLabel } from "../../HomeWork/Styles";
import "../ViewEdit/Test.css";

const DocumentTable = ({ docTableData, documenthead }) => {
  const dispatch = useDispatch();
  const componentRef = useRef();

  const [editopen, setEditopen] = useState("");
  const [iscreate, setIsCreate] = useState();
  const [forprint, setforprint] = useState("");
  const [tosign, settosign] = useState("");
  const [documentlistdata, setdocumentlistdata] = useState([]);
  const [donwloadprintid, setdonwloadprintid] = useState("");
  const [ForViewEdit, setForViewEdit] = useState(false);

  const [isFormOpened, setIsFormOpened] = useState(false);
  const [formData, setFormData] = useState(null);

  const [FileName, setFileName] = useState("");
  const [FileStatus, setFileStatus] = useState("");
  const [ForSign, setForSign] = useState("");
  const [FileId, setFileId] = useState("");
  const [viewedDocs, setViewedDocs] = useState([]);

  let backurl = "";
  let firstDot = window.location.hostname.split(".");
  let DBhost;

  if (firstDot[0] !== "localhost") {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS.replace(
      "oemr",
      firstDot[0],
    );
  } else {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS;
  }

  if (
    firstDot[0] === "localhost" ||
    firstDot[0] === "test" ||
    firstDot[0] === "mumbai" ||
    firstDot[0] === "production" ||
    firstDot[0] === "ehr" ||
    firstDot[0] === "ehr1" ||
    firstDot[0] === "dev"
  ) {
    DBhost = "default";
  } else {
    DBhost = firstDot[0];
  }

  const FileURL = backurl + "/sites/" + DBhost + "/documentimg/";
  const LabFileURL = backurl + "/sites/" + DBhost + "/LabDocuments/";
  const FileURLProfile = backurl + "/sites/" + DBhost + "/documentimg/";

  const PreviewDownload = useSelector(
    (state) => state.Document.previewdownload,
  );
  const DocumentDownloadUrl = useSelector(
    (state) => state.Document.DownloadDocumentlist,
  );
  const LabDocumentDownloadUrl = useSelector((state) => state.Document.LabPdf);

  const setEditAction = (ind) => {
    setEditopen((prev) => (prev === ind ? "" : ind));
  };

  const SentToReview = (ind, id, status) => {
    if (status === "In Review") {
      toast(<Error msg="This Document Already Sent to Review" />, {
        containerId: "B",
        className: "error_badge",
      });
      setEditAction(ind);
    } else if (status === "Locked") {
      toast(<Error msg="This Document is Already Locked" />, {
        containerId: "B",
        className: "error_badge",
      });
      setEditAction(ind);
    } else {
      dispatch(getUpdateDocumentslist({ ids: id }));
      setEditAction(ind);
    }
  };

  const HandlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => dispatch(getDeleteTempDoc({ id: donwloadprintid })),
  });

  const FileDownload = async (fileurl, id, ind) => {
    setdonwloadprintid(id);
    dispatch(getPreviewDownload({ file: fileurl, id: id, testurl: FileURL }));
    setEditAction(ind);
  };

  const HandleDelete = (ind, id) => {
    if (window.confirm("Are you sure you want to Delete?")) {
      dispatch(setPreviewDocument(""));
      setTimeout(() => {
        dispatch(getDeleteDocumentslist({ ids: id }));
        setEditAction(ind);
      }, 0);
    }
  };

  const PreviewDocument = (id, fileurl, print, ind) => {
    setdonwloadprintid(id);
    if (print === "yes") {
      setEditAction(ind);
      setforprint("yes");
    }
    dispatch(getPreviewDocument({ file: fileurl, id: id }));
  };

  const PreviewDocumentEdit = (id, fileurl, fname, status, sign) => {
    setForViewEdit(true);
    setFileName(fname);
    setFileStatus(status);
    setForSign(sign);
    setFileId(id);
    dispatch(getViewEditDocument({ file: fileurl, id: id }));
  };

  const HanldeCloseSignature = () => {
    setIsCreate(false);
    settosign("");
  };

  const HanldeCloseViewEdit = () => {
    setForViewEdit(false);
    dispatch(getDocumentslist({ filtertype: "All Documents" }));
    dispatch(getEditDataEmpty());
  };

  const getFileExtension = (filename) => filename.split(".").pop();

  const handleDownload = (value) => {
    dispatch(getDownloadCredentials({ order_id: value, result: 1 }));
  };

  const handleDownloadLab = (order_id, id, pid, testcode, filename) => {
    dispatch(
      getDownloadLabCredentials({
        order_id,
        id,
        pid,
        testcode,
        filename,
      }),
    );
  };

  const handleClick = (e) => {
    if (!e.target.id) setEditopen("");
  };

  const truncateText = (text, maxLength) =>
    text?.length > maxLength ? text.substring(0, maxLength) + "..." : text;

  const openPatientAssessment = (row) => {
    const formLabel = row.screening_form || row.assess_form || row.form_name;

    if (!formLabel) {
      toast.error("Assessment form name missing");
      return;
    }

    axiosInst
      .get(
        `/vozo/getPatientForm?pid=${row.pid}&formLabel=${formLabel}&docId=${row.id}`,
      )
      .then((response) => {
        let decryptedData =
          typeof response.data === "string"
            ? Decrypt_Value(response.data, "vozo")
            : response.data;

        if (!decryptedData || Object.keys(decryptedData).length === 0) {
          toast.error("Form data not available");
          return;
        }

        decryptedData.pid = row.pid;
        decryptedData.document_id = row.id;

        const hasFilledValues = decryptedData.questions?.some(
          (q) =>
            q.selected_option !== null &&
            q.selected_option !== undefined &&
            q.selected_option !== "" &&
            q.selected_option !== 0,
        );

        decryptedData.isSaved = hasFilledValues;

        setFormData(decryptedData);
        setIsFormOpened(true);
      })
      .catch(() => {
        toast.error("Unable to load assessment form");
      });
  };

  useEffect(() => {
    if (docTableData) {
      const sortedArray = [...docTableData].sort((a, b) => {
        if (a.assignedByDefault === 1 && b.assignedByDefault !== 1) return -1;
        if (b.assignedByDefault === 1 && a.assignedByDefault !== 1) return 1;
        return b.id - a.id;
      });
      setdocumentlistdata(sortedArray);
    }
  }, [docTableData]);

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  useEffect(() => {
    console.log("PreviewDownload updated:", PreviewDownload);
    if (PreviewDownload && PreviewDownload !== "") {
      const isObject = typeof PreviewDownload === "object";
      const file = isObject ? PreviewDownload.file : PreviewDownload;
      const filename = isObject ? PreviewDownload.filename : "document.pdf";
      const downloadId = isObject ? PreviewDownload.id : donwloadprintid;

      if (!file) {
        console.error("No file URL found in PreviewDownload");
        return;
      }

      console.log("Triggering download for:", file);

      let tag = document.createElement("a");
      const fullUrl =
        file?.includes("http") ||
        file?.includes("blob:") ||
        file?.includes("data:")
          ? file
          : (isObject ? PreviewDownload.testurl || FileURL : FileURL) + file;

      tag.href = fullUrl;
      tag.download = filename;
      tag.target = "_blank"; // Fallback for some browsers
      document.body.appendChild(tag);
      tag.click();
      document.body.removeChild(tag);

      // Delay cleanup slightly to ensure trigger is handled by browser
      setTimeout(() => {
        dispatch(getDeleteTempDoc({ id: downloadId }));
      }, 1000);
    }
  }, [PreviewDownload]);

  useEffect(() => {
    if (LabDocumentDownloadUrl !== "") {
      let tag = document.createElement("a");
      tag.href = LabDocumentDownloadUrl.includes("http")
        ? LabDocumentDownloadUrl
        : LabFileURL + LabDocumentDownloadUrl;
      tag.target = "_blank";
      document.body.appendChild(tag);
      tag.click();
      document.body.removeChild(tag);
      dispatch(setDeleteLabCredentials(""));
    }
  }, [LabDocumentDownloadUrl]);

  const getStatusStyle = (status) => {
    switch (status) {
      case "Pending":
        return {
          bg: "rgba(255, 99, 71, 0.1)",
          color: "#ff6347",
          width: "90px",
        };

      case "Signed":
        return {
          bg: "rgba(40, 167, 69, 0.1)",
          color: "#28a745",
          width: "80px",
        };

      case "Unsigned":
        return {
          bg: "rgba(255, 159, 67, 0.1)",
          color: "#ff9f43",
          width: "95px",
        };

      case "In Review":
        return {
          bg: "rgba(132, 129, 138, 0.15)",
          color: "#84818a",
          width: "95px",
        };

      case "New":
        return {
          bg: "rgba(0, 165, 255, 0.1)",
          color: "#00a5ff",
          width: "65px",
        };

      case "Viewed":
        return {
          bg: "rgba(111, 66, 193, 0.1)",
          color: "#6f42c1",
          width: "90px",
        };

      case "Completed":
        return {
          bg: "rgba(40, 167, 69, 0.15)",
          color: "#218838",
          width: "100px",
        };

      default:
        return { bg: "rgba(132,129,138,0.1)", color: "#2e2c34", width: "80px" };
    }
  };

  return (
    <>
      {documenthead === "Lab Results" ? (
        <TableDiv>
          <Iframe
            seamless="seamless"
            width="100%"
            height="800px"
            ref={componentRef}
            src={FileURL + DocumentDownloadUrl}
          />
          <LinkA
            href={FileURL + DocumentDownloadUrl}
            target="_blank"
            id="preview_document"
          />
          <LinkA
            href={LabFileURL + LabDocumentDownloadUrl}
            target="_blank"
            id="lab_preview_document"
          />

          <Table>
            <TableHead>
              <TableRow background="#F7F7F7">
                <TableHeadCell width="19%" color="#407BFF">
                  Form
                </TableHeadCell>
                <TableHeadCell width="17%" color="#407BFF">
                  Title
                </TableHeadCell>
                <TableHeadCell
                  width="15%"
                  color="#407BFF"
                  style={{
                    paddingRight: "20px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Associate Patient
                </TableHeadCell>
                <TableHeadCell width="15%" color="#407BFF">
                  Created
                </TableHeadCell>
                <TableHeadCell width="15%" color="#407BFF">
                  Updated
                </TableHeadCell>
                <TableHeadCell width="5%" color="#407BFF">
                  Download
                </TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <>
                {documentlistdata.length > 0 ? (
                  <>
                    {documentlistdata.map((row, ind) => (
                      <TableRow background="#FFFFF" key={row.id}>
                        <TableBodyCell
                          fontFamily="'Inter',sans-serif"
                          padding="16px 40px 10px 38px;"
                          cursor="pointer"
                          onClick={() => {
                            if (row.name === "lab") {
                              handleDownloadLab(
                                row.order_id,
                                row.procedure_order_id,
                                row.patient_id,
                                row.vendor + "-" + row.tests,
                                row.filename,
                              );
                            } else {
                              PreviewDocument(row.id, row.file_url, "no", ind);
                            }
                          }}
                        >
                          {" "}
                          <FlexJustCenter>
                            <TitleLabel
                              fontFamily="'Inter',sans-serif"
                              fontSize="14px"
                              fontHeight="16px"
                              fontWeight="normal"
                              color="#000000"
                              title={row.vendor}
                            >
                              {row.vendor}
                            </TitleLabel>
                          </FlexJustCenter>
                        </TableBodyCell>
                        <TableBodyCell
                          fontFamily="'Inter',sans-serif"
                          padding="16px 40px 10px 38px;"
                        >
                          {row.tests}
                        </TableBodyCell>
                        <TableBodyCell
                          display="flex"
                          fontFamily="'Inter',sans-serif"
                          padding="16px 40px 10px 38px;"
                          alignItems="center"
                        >
                          {row.pat_img_url !== null ? (
                            <Image
                              objectFit="cover"
                              loading="lazy"
                              width="28px"
                              height="28px"
                              borderRadius="50%"
                              margin="0 12px 0 0"
                              src={FileURLProfile + row.pat_img_url}
                            />
                          ) : (
                            <ProfileNameText>
                              {row.pat_name.charAt(0).toUpperCase()}
                            </ProfileNameText>
                          )}
                          {row.pat_name}
                        </TableBodyCell>

                        <TableBodyCell padding="16px 40px 10px 38px;">
                          {moment(row.date_submit).calendar(null, {
                            sameDay: "[Today]",
                            nextDay: "[Tomorrow]",
                            nextWeek: "dddd",
                            lastDay: "[Yesterday]",
                            lastWeek: "DD MMM  YYYY ",
                            sameElse: "DD MMM  YYYY ",
                          })}
                        </TableBodyCell>
                        <TableBodyCell padding="16px 40px 10px 38px;">
                          {moment(row.update_date).calendar(null, {
                            sameDay: "[Today]",
                            nextDay: "[Tomorrow]",
                            nextWeek: "dddd",
                            lastDay: "[Yesterday]",
                            lastWeek: "DD MMM  YYYY ",
                            sameElse: "DD MMM  YYYY ",
                          })}
                        </TableBodyCell>
                        <TableBodyCell padding="16px 68px 10px 38px;">
                          <StatusDiv
                            width="32px"
                            background="#FFFFFF"
                            style={{
                              boxShadow:
                                "0px 1px 3px rgba(0, 0, 0, 0.07), 0px 0.5px 2px rgba(0, 0, 0, 0.07)",
                              borderRadius: "4px",
                              float: "right",
                              cursor:
                                row.status !== "active"
                                  ? "pointer"
                                  : "not-allowed",
                              height: "32px",
                              display: "flex",
                            }}
                            onClick={() => {
                              if (row.status !== "active") {
                                if (row.name === "lab") {
                                  handleDownloadLab(
                                    row.order_id,
                                    row.procedure_order_id,
                                    row.patient_id,
                                    row.vendor + "-" + row.tests,
                                    row.filename,
                                  );
                                } else {
                                  handleDownload(row.order_id);
                                }
                              }
                            }}
                          >
                            <FiDownload
                              style={{
                                height: "18px",
                                width: "18px",
                                color: " #2c7be5",
                                cursor:
                                  row.status !== "active"
                                    ? "pointer"
                                    : "not-allowed",
                              }}
                            />
                          </StatusDiv>
                        </TableBodyCell>
                      </TableRow>
                    ))}
                  </>
                ) : (
                  <TableRow background="#FFFFF">
                    <TableBodyCell colSpan={5} textAlign="center">
                      <EmptyData />
                    </TableBodyCell>
                  </TableRow>
                )}
              </>
            </TableBody>
          </Table>
        </TableDiv>
      ) : (
        <TableDiv>
          <Iframe
            seamless="seamless"
            width="100%"
            height="800px"
            ref={componentRef}
            src={FileURL + DocumentDownloadUrl}
          />
          <LinkA
            href={FileURL + DocumentDownloadUrl}
            target="_blank"
            id="preview_document"
          />

          <Table>
            <TableHead>
              <TableRow background="#F7F7F7">
                <TableHeadCell width="28%" color="#407BFF">
                  Document
                </TableHeadCell>
                <TableHeadCell
                  width="18%"
                  color="#407BFF"
                  style={{ whiteSpace: "nowrap", paddingLeft: "16px" }}
                >
                  Create Date
                </TableHeadCell>
                <TableHeadCell width="18%" color="#407BFF">
                  Shared By
                </TableHeadCell>
                <TableHeadCell width="15%" color="#407BFF">
                  Type
                </TableHeadCell>
                <TableHeadCell
                  width="12%"
                  color="#407BFF"
                  padding="20px 0px 20px 70px"
                >
                  Status
                </TableHeadCell>
                <TableHeadCell width="9%" color="#407BFF">
                  Action
                </TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <>
                {documentlistdata.length > 0 ? (
                  <>
                    {documentlistdata.map((row, ind) => (
                      <TableRow background="#FFFFF" key={row.id}>
                        <TableBodyCell
                          fontFamily="'Inter',sans-serif"
                          padding="16px 40px 10px 38px;"
                          cursor="pointer"
                          width="28%"
                          whiteSpace="normal"
                          overflowWrap="break-word"
                          onClick={() => {
                            // if (
                            //   row.document_type?.toLowerCase() === "assessment"
                            // ) {
                            //   openPatientAssessment(row);
                            //   return;
                            // }
                            if (row.screening_form || row.assess_form) {
                              openPatientAssessment(row);
                              return;
                            }

                            if (
                              row.status === "In Review" ||
                              row.status === "Locked" ||
                              row.is_share !== "yes"
                            ) {
                              PreviewDocument(row.id, row.file_url, "no", ind);
                              return;
                            }

                            if (
                              row.tags === "By Provider" ||
                              row.tags === "PCE"
                            ) {
                              PreviewDocument(row.id, row.file_url, "no", ind);
                              return;
                            }

                            PreviewDocumentEdit(
                              row.id,
                              row.file_url,
                              row.form_name,
                              row.status,
                              row.req_pat_sign,
                            );
                          }}
                        >
                          <FlexJustCenter>
                            <TitleLabel
                              cursor="pointer"
                              fontFamily="'Inter',sans-serif"
                              fontSize="14px"
                              fontHeight="16px"
                              fontWeight="normal"
                              color="#000000"
                              title={row.form_name}
                            >
                              {truncateText(row.form_name, 26)}
                            </TitleLabel>
                          </FlexJustCenter>
                        </TableBodyCell>
                        <TableBodyCell
                          fontFamily="'Inter',sans-serif"
                          padding="16px 40px 10px 16px;"
                          whiteSpace="nowrap"
                        >
                          {row.date}
                        </TableBodyCell>
                        <TableBodyCell
                          display="flex"
                          fontFamily="'Inter',sans-serif"
                          padding="16px 40px 10px 38px;"
                          alignItems="center"
                          width="max-content"
                        >
                          {row.prov_img_url !== null ? (
                            <Image
                              objectFit="cover"
                              loading="lazy"
                              width="28px"
                              height="28px"
                              borderRadius="50%"
                              margin="0 12px 0 0"
                              src={FileURLProfile + row.prov_img_url}
                            />
                          ) : (
                            <ProfileNameText>
                              {row.prov_name_split}
                            </ProfileNameText>
                          )}
                          {row.username}
                        </TableBodyCell>
                        <TableBodyCell padding="16px 0px 10px 38px;">
                          {row.screening_form
                            ? "Assessment"
                            : row.assess_form
                              ? "Assessment"
                              : row.document_type
                                ? row.document_type
                                : row.form_name
                                      ?.toLowerCase()
                                      .includes("intake")
                                  ? "Intake"
                                  : "Others"}
                        </TableBodyCell>
                        {/* <TableBodyCell padding="16px 0px 10px 38px;">
                          {row.status === "In Review" && (
                            <StatusDiv
                              width="80px"
                              background="rgba(32, 201, 172, 0.1)"
                            >
                              <StatusText color="#20c9ac">
                                {row.status}
                              </StatusText>
                            </StatusDiv>
                          )}
                          {row.status === "New" && (
                            <StatusDiv
                              width="50px"
                              background=" rgba(0, 165, 255, 0.1)"
                            >
                              <StatusText color="#00a5ff">
                                {row.status}
                              </StatusText>
                            </StatusDiv>
                          )}
                          {row.status === "Locked" && (
                            <StatusDiv
                              width="80px"
                              background="rgba(132, 129, 138, 0.1)"
                            >
                              <StatusText color="#2e2c34">
                                {row.status}
                              </StatusText>
                            </StatusDiv>
                          )}
                        </TableBodyCell> */}
                        <TableBodyCell padding="16px 0px 10px 38px;">
                          {(() => {
                            // const displayStatus =
                            //   row.status === "Locked"
                            //     ? "Completed"
                            //     : row.status;
                            let displayStatus = row.status;

                            const isAssessment =
                              row.screening_form || row.assess_form;

                            if (!isAssessment && viewedDocs.includes(row.id)) {
                              displayStatus = "Viewed";
                            }

                            /* 🔥 GLOBAL FIX */
                            if (row.status === "Locked") {
                              displayStatus = "Signed";
                            }

                            if (isAssessment) {
                              if (row.status === "New") {
                                displayStatus = "Pending";
                              } else if (row.status === "Unsigned") {
                                displayStatus = "Unsigned";
                              } else if (row.status === "Signed") {
                                displayStatus = "Signed";
                              } else if (row.status === "In Review") {
                                displayStatus = "In Review";
                              }
                            }

                            const style = getStatusStyle(displayStatus);

                            return (
                              <StatusDiv
                                width={style.width}
                                background={style.bg}
                              >
                                <StatusText color={style.color}>
                                  {displayStatus}
                                </StatusText>
                              </StatusDiv>
                            );
                          })()}
                        </TableBodyCell>
                        <TableBodyCell
                          padding="16px 40px 10px 38px;"
                          style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            gap: "14px",
                          }}
                        >
                          {/* Conditional View / Edit Icon */}
                          {row.status === "New" ||
                          row.status === "Viewed" ||
                          row.status === "Unsigned" ||
                          row.status === "Pending" ? (
                            <FiEye
                              style={{
                                fontSize: 18,
                                cursor: "pointer",
                                color: "#212121",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();

                                /* 🔥 STATUS CHANGE FIX */
                                const isAssessment =
                                  row.screening_form || row.assess_form;

                                if (row.status === "New" && !isAssessment) {
                                  setViewedDocs((prev) => [...prev, row.id]);
                                }

                                if (row.screening_form || row.assess_form) {
                                  openPatientAssessment(row);
                                  return;
                                }

                                if (
                                  row.status === "In Review" ||
                                  row.status === "Locked" ||
                                  row.is_share !== "yes"
                                ) {
                                  PreviewDocument(
                                    row.id,
                                    row.file_url,
                                    "no",
                                    ind,
                                  );
                                  return;
                                }

                                if (
                                  row.tags === "By Provider" ||
                                  row.tags === "PCE"
                                ) {
                                  PreviewDocument(
                                    row.id,
                                    row.file_url,
                                    "no",
                                    ind,
                                  );
                                  return;
                                }

                                PreviewDocumentEdit(
                                  row.id,
                                  row.file_url,
                                  row.form_name,
                                  row.status,
                                  row.req_pat_sign,
                                );
                              }}
                            />
                          ) : (
                            <FiEdit
                              style={{
                                fontSize: 18,
                                cursor: "pointer",
                                color: "#212121",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                PreviewDocumentEdit(
                                  row.id,
                                  row.file_url,
                                  row.form_name,
                                  row.status,
                                  row.req_pat_sign,
                                );
                              }}
                            />
                          )}

                          {/* Triple Dot */}
                          <BsThreeDots
                            id="icon"
                            style={{ fontSize: 20, cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setEditAction(ind);
                            }}
                          />

                          <DropdownContent
                            marginLeft="-138px"
                            width="179px"
                            marginRight="16px"
                            display={editopen === ind ? "true" : "false"}
                            share={row.is_share}
                          >
                            {row.is_share !== "yes" && (
                              <>
                                {row.status !== "Locked" && (
                                  <DropdownList
                                    id="list"
                                    padding="0px 0px 3px 20px"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      SentToReview(ind, row.id, row.status);
                                    }}
                                  >
                                    <Image
                                      objectFit="cover"
                                      width="16px"
                                      height="16px"
                                      margin="0px 16px 0px 0px"
                                      src={forward}
                                      id="doc_rvw-snt_img"
                                    />
                                    Sent to Review
                                  </DropdownList>
                                )}
                              </>
                            )}

                            {(row.status === "In Review" ||
                              (row.is_share !== "yes" &&
                                (row.status === "New" ||
                                  row.status === "Locked" ||
                                  row.status === "In Review"))) && (
                              <>
                                <DropdownList
                                  id="list2"
                                  padding="0px 0px 3px 20px"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    PreviewDocument(
                                      row.id,
                                      row.file_url,
                                      "yes",
                                      ind,
                                    );
                                  }}
                                >
                                  <Image
                                    loading="lazy"
                                    width="16px"
                                    height="16px"
                                    margin="0px 16px 0px 0px"
                                    src={printer}
                                  />
                                  Print
                                </DropdownList>
                                <DropdownList
                                  id="list3"
                                  padding="0px 0px 3px 20px"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    FileDownload(row.file_url, row.id, ind);
                                  }}
                                >
                                  <Image
                                    loading="lazy"
                                    width="16px"
                                    height="16px"
                                    margin="0px 16px 0px 0px"
                                    src={Download}
                                  />
                                  Download
                                </DropdownList>
                              </>
                            )}
                            {row.status !== "Locked" && (
                              <DropdownList
                                id="list4"
                                padding="0px 0px 3px 20px"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  HandleDelete(ind, row.id);
                                }}
                              >
                                <Image
                                  loading="lazy"
                                  width="16px"
                                  height="16px"
                                  margin="0px 16px 0px 0px"
                                  src={Delete}
                                />
                                Delete
                              </DropdownList>
                            )}
                          </DropdownContent>
                        </TableBodyCell>
                      </TableRow>
                    ))}
                  </>
                ) : (
                  <TableRow background="#FFFFF">
                    <TableBodyCell colSpan={5} textAlign="center">
                      <EmptyData />
                    </TableBodyCell>
                  </TableRow>
                )}
              </>
            </TableBody>
          </Table>
        </TableDiv>
      )}
      <CreateSignature
        show={iscreate}
        close={HanldeCloseSignature}
        ids={tosign}
      />
      <ViewEdit
        show={ForViewEdit}
        filename={FileName}
        filestatus={FileStatus}
        fileid={FileId}
        close={HanldeCloseViewEdit}
        forsign={ForSign}
      />

      {isFormOpened && (
        <div className="form-popup-overlay">
          <div className="form-popup">
            <PatientForm
              setIsFormOpened={setIsFormOpened}
              formData={formData}
              setFormData={setFormData}
              // setFormData={(data) => {
              //   setFormData(data);
              //   handleSavePatientForm(data);
              // }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default memo(DocumentTable);
